import { combineReducers } from 'redux'
import { createReducer } from '../../utils/helpers'

const initialState = {
  config: {
    title: 'Bauland',
    path: 'bauland',
    selectionKey: 'plot',
    component: 'Plot',
    description: 'Hilfetext für das Info-Icon neben dem Titel',
    minSelect: 1,
    maxSelect: 1,
  },
  nodes: [
    {
      id: '1',
      title: 'Ich suche Bauland',
      images: ['images/static/landSearch.svg'],
      value: true,
    },
    {
      id: '2',
      title: 'Ich habe Bauland',
      images: ['images/static/landCheck.svg'],
      value: false,
    },
  ],
  linkTile: {
    linkUrl: 'https://www.hausconcept.ch/sie-wuenschen/immobilien-bauland/',
    linkDescription: 'Wir haben auch Bauland. Besuchen Sie unsere Website.',
    linkButton: 'Angebot anzeigen',
  },
}

export const config = createReducer(initialState.config, {})

export const nodes = createReducer(initialState.nodes, {})

export const linkTile = createReducer(initialState.linkTile, {})

// Default Export
export default combineReducers({
  config,
  nodes,
  linkTile,
})



// WEBPACK FOOTER //
// ./src/modules/plot/reducers.js